import React from 'react';
import { useTranslation } from 'react-i18next';
import { Taxonomy } from '@uncinc/react-drupal-core';

import './style.scss';

const ViewPillars = ({ entities, link }) => {
  const { t } = useTranslation();

  return (
    <div className="ViewPillars">
      <h2>{t('implementations.taxonomy.pillar_categories')}</h2>
      <div className="ViewPillars__Items">
        {entities.map((entity, index) => (
          <Taxonomy
            key={entity.getIn(['uuid', 0, 'value'], index)}
            viewMode="teaser"
            entity={entity}
            link={link}
          />
        ))}
      </div>
    </div>
  );
};

export default ViewPillars;
